// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72451d44","453":"1471ff96","455":"4a961717"}[chunkId] + ".chunk.js";
};